<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="750px"
    :innerScroll="false"
    :loading="loadingButtom"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="addForm" ref="addForm" :rules="rules" size="small" label-width="80px" class="content">
      <el-row>
        <el-col :span="8">
          <el-form-item label="质检条目" prop="checkCategory">
            <el-input v-model.trim="addForm.checkCategory" disabled maxlength="100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="违规项" prop="categoryDetail">
            <el-input v-model.trim="addForm.categoryDetail" disabled maxlength="100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="生效时间" prop="effectDate">
            <!-- <el-date-picker v-model="addForm.effectDate" type="date" value-format="yyyyMMdd" placeholder="选择时间"> </el-date-picker> -->
            <el-date-picker
              v-model="addForm.effectDate"
              type="date"
              value-format="yyyyMMdd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="场景" prop="scene">
            <el-input v-model.trim="addForm.scene" maxlength="100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="扣分" prop="assessmentScore">
            <el-input v-model.trim="addForm.assessmentScore" maxlength="100"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
import axios from "@/utils/axiosInstance";
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // refundReasonList: {
    //   type: Array,
    //   default: [],
    // },
    rowData: Object,
  },
  data() {
    return {
      addForm: {
      },
      userId: "",
      userList: [],
      all: false,
      rules: {
        checkCategory: [{ required: true, message: "不能为空", trigger: "blur" }],
        categoryDetail: [{ required: true, message: "不能为空", trigger: "blur" }],
        scene: [{ required: true, message: "不能为空", trigger: "blur" }],
        assessmentScore: [{ required: true, message: "不能为空", trigger: "blur" }],
        effectDate: [{ required: true, message: "不能为空", trigger: "change" }],
      },
      loading: false,
      loadingButtom: false,
      authOptions: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "编辑";
    },
  },
  mounted() {
    if (this.rowData) {
      let addForm = JSON.parse(JSON.stringify(this.rowData));
      addForm.effectDate = addForm.effectDate + ''
      this.addForm = addForm;
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        this.$q.qualityTestingManage
          .projectConfigUpdate({ data: this.addForm })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("编辑成功");
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 150px !important
>>> .el-input
  width 150px !important
>>> .el-row 
  display flex
  flex-wrap wrap
</style>
